import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import { Link, useLocation,useNavigate } from 'react-router-dom';
import { RP_FORM_MANDATORY_STATUS, RP_FORM_STATUS } from "../../../../constants/cms";
import Cookies from "universal-cookie";



const ManageInputForm = ({ fieldTypeFields, fieldTypeData, initialValues, inputFlowTypeData, productId, mappedProcessTypeData, mappedCategoryData, submit, id, postCreateFormDetailError, clearPostCreateFormDetailMessageResponse, dispatch }) => {
    const defaultPlaceholders = {
        "User Input": "Enter expected score",
        "Application Number": "Exam's application number",
        "Category Dropdown": "Select",
        "Select List Dropdown": "Select",
        "Radio Button": "Select",
        "Date of Birth": "Select"
    };
    const navigate = useNavigate();
    const cookies = new Cookies();
    const location = useLocation();
    const goBack = () => {
        const selected_product=cookies.get("selected_rp_product")
      navigate('/cms/manage-rp/create-form',{
        state: { product_id: location.state?.product_id||selected_product?.id,value:location.state?.value||selected_product?.value },
      }); // Go to the previous page in history
    };
    const {postCreateFormDetailMessage}=useSelector((state) => state.manageRP_Reducer);
    useEffect(()=>{
        if(postCreateFormDetailError?.error){
        dispatch(clearPostCreateFormDetailMessageResponse())}
    },[])

    useEffect(()=>{
        let reDirecter;
        // to redirect to previous page after submit
        if(postCreateFormDetailMessage  && !postCreateFormDetailError){

          reDirecter=setTimeout(()=>{
            cookies?.remove('selected_rp_product', {
                path: "/",
                domain: window.location.hostname,
              })
            goBack()
          },500)
        }
        return()=>{
            if(reDirecter){
                clearTimeout(reDirecter)
            }
        }
    },[postCreateFormDetailMessage])

    return (
        <div className={"manage_access"}>
            <Formik
                initialValues={initialValues}
                validate={(values) => {
                    const errors = {};

                    if (!values?.field_type) {
                        errors.field_type = "Required.";
                    }

                    switch (values?.field_type?.value) {
                        case "User Input":
                            if (!values?.input_flow_type) {
                                errors.input_flow_type = "Required.";
                            }
                            if (!values?.display_name || values?.display_name?.trim() == "") {
                                errors.display_name = "Required.";
                            } else if (values?.display_name?.length > 50) {
                                errors.display_name = "Display Name can't exceed 50 characters.";
                            }
                            if (!values?.place_holder_text || values?.place_holder_text?.trim() == "") {
                                errors.place_holder_text = "Required.";
                            } else if (values?.place_holder_text?.length > 50) {
                                errors.place_holder_text = "Place Holder Text can't exceed 50 characters.";
                            }
                            if (values?.error_message?.length > 50) {
                                errors.error_message = "Error Message can't exceed 50 characters.";
                            }
                            if (values?.min_val === null || values?.min_val === undefined || values?.min_val === "") {
                                errors.min_val = "Required.";
                            }
                            if (values?.max_val === null || values?.max_val === undefined || values?.max_val === "") {
                                errors.max_val = "Required.";
                            }
                            if (!values?.weight && values?.weight !==0) {
                                errors.weight = "Required.";
                            }
                            break;

                        case "Application Number":
                            if (!values?.display_name || values?.display_name?.trim() == "") {
                                errors.display_name = "Required.";
                            } else if (values?.display_name?.length > 50) {
                                errors.display_name = "Display Name can't exceed 50 characters.";
                            }
                            if (!values?.place_holder_text || values?.place_holder_text?.trim() == "") {
                                errors.place_holder_text = "Required.";
                            } else if (values?.place_holder_text?.length > 50) {
                                errors.place_holder_text = "Place Holder Text can't exceed 50 characters.";
                            }
                            if (values?.error_message?.length > 50) {
                                errors.error_message = "Error Message can't exceed 50 characters.";
                            }
                            if (values?.weight === null || values?.weight === undefined || values?.weight === "") {
                                errors.weight = "Required.";
                            }
                            break;

                        case "Category Dropdown":
                            if (!values?.display_name || values?.display_name?.trim() == "") {
                                errors.display_name = "Required.";
                            } else if (values?.display_name?.length > 50) {
                                errors.display_name = "Display Name can't exceed 50 characters.";
                            }
                            if (!values?.place_holder_text || values?.place_holder_text?.trim() == "") {
                                errors.place_holder_text = "Required.";
                            } else if (values?.place_holder_text?.length > 50) {
                                errors.place_holder_text = "Place Holder Text can't exceed 50 characters.";
                            }
                            if (values?.error_message?.length > 50) {
                                errors.error_message = "Error Message can't exceed 50 characters.";
                            }
                            if (!values?.mapped_category) {
                                errors.mapped_category = "Required.";
                            }
                            if (values?.weight === null || values?.weight === undefined || values?.weight === "") {
                                errors.weight = "Required.";
                            }
                            break;

                        case "Select List Dropdown":
                            if (!values?.display_name || values?.display_name?.trim() == "") {
                                errors.display_name = "Required.";
                            } else if (values?.display_name?.length > 50) {
                                errors.display_name = "Display Name can't exceed 50 characters.";
                            }
                            if (!values?.place_holder_text || values?.place_holder_text?.trim() == "") {
                                errors.place_holder_text = "Required.";
                            } else if (values?.place_holder_text?.length > 50) {
                                errors.place_holder_text = "Place Holder Text can't exceed 50 characters.";
                            }
                            if (!values?.list_option_data) {
                                errors.list_option_data = "Required.";
                            }
                            if (values?.error_message?.length > 50) {
                                errors.error_message = "Error Message can't exceed 50 characters.";
                            }
                            if (values?.weight === null || values?.weight === undefined || values?.weight === "") {
                                errors.weight = "Required.";
                            }
                            break;

                        case "Radio Button":
                            if (!values?.display_name || values?.display_name?.trim() == "") {
                                errors.display_name = "Required.";
                            } else if (values?.display_name?.length > 50) {
                                errors.display_name = "Display Name can't exceed 50 characters.";
                            }
                            if (!values?.list_option_data) {
                                errors.list_option_data = "Required.";
                            }
                            if (values?.weight === null || values?.weight === undefined || values?.weight === "") {
                                errors.weight = "Required.";
                            }
                            break;

                        case "Date of Birth":
                            if (!values?.display_name || values?.display_name?.trim() == "") {
                                errors.display_name = "Required.";
                            } else if (values?.display_name?.length > 50) {
                                errors.display_name = "Display Name can't exceed 50 characters.";
                            }
                            if (!values?.place_holder_text || values?.place_holder_text?.trim() == "") {
                                errors.place_holder_text = "Required.";
                            } else if (values?.place_holder_text?.length > 50) {
                                errors.place_holder_text = "Place Holder Text can't exceed 50 characters.";
                            }
                            if (values?.weight === null || values?.weight === undefined || values?.weight === "") {
                                errors.weight = "Required.";
                            }
                            if (values?.error_message?.length > 50) {
                                errors.error_message = "Error Message can't exceed 50 characters.";
                            }
                            break;

                        default:
                            break;
                    }

                    return errors;
                }}
                enableReinitialize={true}
                onSubmit={(values) => {
                    submit(values);
                }}
            >

                {({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                }) => {
                    const selectedFieldType = values.field_type?.value;
                    const fieldsToRender = fieldTypeFields[selectedFieldType] || [];
                    // console.log(",,,selectedFieldType1",selectedFieldType)

                    useEffect(() => {
                        if (selectedFieldType in defaultPlaceholders) {
                            if (id) {

                                setFieldValue("place_holder_text", values?.place_holder_text);
                            }
                            else {
                                setFieldValue("place_holder_text", defaultPlaceholders[selectedFieldType]);
                            }
                        }
                    }, [selectedFieldType, setFieldValue]);

                    const preventTyping = (event, fieldName) => {
                        const fieldLengthLimits = {
                            display_name: 51,
                            place_holder_text: 51,
                            error_message: 51,
                        };

                        const maxLength = fieldLengthLimits[fieldName];
                        const isBackspace = event.key === "Backspace";
                        const currentValue = values?.[fieldName] || "";

                        if (maxLength !== undefined) {
                            if (!isBackspace && currentValue.length >= maxLength) {
                                event.preventDefault();
                            } else {
                                setFieldValue(fieldName, event.target.value);
                            }
                        }
                    };
                    return (
                        <form onSubmit={handleSubmit}>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="/cms">Home</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="/cms/manage-rp/create-form">Create Form</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        {id ? "Edit Input Field Mapping" : "Add Input Field Mapping"}
                                    </li>
                                </ol>
                            </nav>
                            <div className={"basic_details"}>
                                <div className={"examfilter"}>
                                    <h4 className={"examfilter_heading"}>{id ? "Edit Input Field Mapping" : "Add Input Field Mapping"}</h4>
                                    <Row>
                                        <Col md={4} className="mb-4">
                                            <Form.Group>
                                                <Form.Label>Field Type<sup className="icon_star">*</sup></Form.Label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    name={`field_type`}
                                                    placeholder="Select Field Type"
                                                    value={
                                                        values.field_type
                                                    }
                                                    onBlur={() => {
                                                        handleBlur({
                                                            target: {
                                                                name: `field_type`,
                                                            },
                                                        });
                                                    }}
                                                    onChange={(value) => {
                                                        setFieldValue(`field_type`, value);

                                                        // Clear other field values when field_type changes
                                                        setFieldValue(`input_flow_type`, null);
                                                        setFieldValue(`display_name`, '');
                                                        setFieldValue(`place_holder_text`, '');
                                                        setFieldValue(`error_message`, '');
                                                        setFieldValue(`min_val`, '');
                                                        setFieldValue(`max_val`, '');
                                                        setFieldValue(`weight`, '');
                                                        setFieldValue(`mapped_process_type`, mappedProcessTypeData?.mapped_process_type?.length === 1 ? mappedProcessTypeData?.mapped_process_type?.[0] : '');
                                                        setFieldValue(`mapped_category`, null);
                                                        setFieldValue(`mandatory`, null);
                                                        setFieldValue(`status`, null);
                                                        setFieldValue(`list_option_data`, '');

                                                        // Clear any post-create messages
                                                        dispatch(clearPostCreateFormDetailMessageResponse());
                                                    }}

                                                    isDisabled={id}
                                                    options={fieldTypeData}
                                                    getOptionLabel={(option) => option.value}
                                                    getOptionValue={(option) => option.id}
                                                />
                                                {errors.field_type && touched.field_type && (
                                                    <div className="error">{errors.field_type}</div>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {fieldsToRender.includes("input_flow_type") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Input Flow Type<sup className="icon_star">*</sup></Form.Label>
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`input_flow_type`}
                                                        placeholder="Select Input Flow Type"
                                                        value={
                                                            values.input_flow_type
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `input_flow_type`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) => {
                                                            setFieldValue(
                                                                `input_flow_type`,
                                                                value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())

                                                        }
                                                        }
                                                        options={inputFlowTypeData}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                    />
                                                    {errors.input_flow_type && touched.input_flow_type && (
                                                        <div className="error">{errors.input_flow_type}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("display_name") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Display Name<sup className="icon_star">*</sup></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="display_name"
                                                        placeholder="Enter Display Name"
                                                        onChange={(event) => {
                                                            let value = event.target.value;
                                                            value = value.replace(/^\s+/g, "");
                                                            setFieldValue(
                                                                `display_name`,
                                                                value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.display_name}
                                                        onKeyDown={(e) => preventTyping(e, "display_name")}
                                                    />
                                                    {errors.display_name && touched.display_name && (
                                                        <div className="error">{errors.display_name}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("place_holder_text") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Placeholder<sup className="icon_star">*</sup></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="place_holder_text"
                                                        placeholder="Enter Place Holder Text"
                                                        onChange={(event) => {
                                                            let value = event.target.value;
                                                            value = value?.replace(/^\s+/g, "");
                                                            setFieldValue(
                                                                `place_holder_text`,
                                                                value
                                                            )
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.place_holder_text}
                                                        onKeyDown={(e) => preventTyping(e, "place_holder_text")}
                                                    />
                                                    {errors.place_holder_text && touched.place_holder_text && (
                                                        <div className="error">{errors.place_holder_text}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("mapped_category") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Mapped Category<sup className="icon_star">*</sup></Form.Label>
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`mapped_category`}
                                                        placeholder="Select Mapped Category"
                                                        value={
                                                            values.mapped_category
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `mapped_category`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) => {
                                                            setFieldValue(
                                                                `mapped_category`,
                                                                value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())

                                                        }
                                                        }
                                                        options={mappedCategoryData}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                    />
                                                    {errors.mapped_category && touched.mapped_category && (
                                                        <div className="error">{errors.mapped_category}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("list_option_data") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>List Option Data<sup className="icon_star">*</sup></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="list_option_data"
                                                        placeholder="Enter List Option Data"
                                                        onChange={(event) => {
                                                            let value = event.target.value;
                                                            value = value?.replace(/^\s+/g, "");
                                                            setFieldValue(
                                                                `list_option_data`,
                                                                  value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())

                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.list_option_data}
                                                    />
                                                    {errors.list_option_data && touched.list_option_data && (
                                                        <div className="error">{errors.list_option_data}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("error_message") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Error Message</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className={"input_pd"}
                                                        name="error_message"
                                                        placeholder="Enter Error Message"
                                                        onChange={(event) => {
                                                            let value = event.target.value;
                                                            value = value?.replace(/^\s+/g, "");
                                                            setFieldValue(
                                                                `error_message`,
                                                                 value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())

                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                        value={values?.error_message}
                                                        onKeyDown={(e) => preventTyping(e, "error_message")}

                                                    />
                                                    {errors.error_message && touched.error_message && (
                                                        <div className="error">{errors.error_message}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("min_val") && (
                                            <Col sm={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Min Val<sup className="icon_star">*</sup></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        className={"input_pd"}
                                                        name="min_val"
                                                        placeholder="Enter Min Value"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.min_val}
                                                    />
                                                    {errors.min_val && touched.min_val && (
                                                        <div className="error">{errors.min_val}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("max_val") && (
                                            <Col sm={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Max Val<sup className="icon_star">*</sup></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        className={"input_pd"}
                                                        name="max_val"
                                                        placeholder="Enter Max Value"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.max_val}
                                                    />
                                                    {errors.max_val && touched.max_val && (
                                                        <div className="error">{errors.max_val}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("weight") && (
                                            <Col sm={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Weight<sup className="icon_star">*</sup></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        className={"input_pd"}
                                                        name="weight"
                                                        placeholder="Enter Weight"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.weight}
                                                    />
                                                    {errors.weight && touched.weight && (
                                                        <div className="error">{errors.weight}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("mapped_process_type") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Mapped Process Type</Form.Label>
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`mapped_process_type`}
                                                        placeholder="Select Mapped Process Type"
                                                        value={
                                                            values?.mapped_process_type
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `mapped_process_type`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) => {
                                                            setFieldValue(
                                                                `mapped_process_type`,
                                                                value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())

                                                        }
                                                        }
                                                        isClearable
                                                        options={mappedProcessTypeData?.mapped_process_type}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                    />
                                                    {errors.mapped_process_type && touched.mapped_process_type && (
                                                        <div className="error">{errors.mapped_process_type}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("mandatory") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Mandatory</Form.Label>
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`mandatory`}
                                                        placeholder="Mandatory"
                                                        value={
                                                            values.mandatory
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `mandatory`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) => {
                                                            setFieldValue(
                                                                `mandatory`,
                                                                value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())

                                                        }
                                                        }
                                                        isClearable
                                                        options={RP_FORM_MANDATORY_STATUS}
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => option.value}
                                                    />
                                                    {errors.mandatory && touched.mandatory && (
                                                        <div className="error">{errors.mandatory}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {fieldsToRender.includes("status") && (
                                            <Col md={4} className="mb-4">
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        name={`status`}
                                                        placeholder="Status"
                                                        value={
                                                            values.status
                                                        }
                                                        onBlur={() => {
                                                            handleBlur({
                                                                target: {
                                                                    name: `status`,
                                                                },
                                                            });
                                                        }}
                                                        onChange={(value) => {
                                                            setFieldValue(
                                                                `status`,
                                                                value
                                                            )
                                                            dispatch(clearPostCreateFormDetailMessageResponse())
                                                        }
                                                        }
                                                        isClearable
                                                        options={RP_FORM_STATUS}
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => option.value}
                                                    />
                                                    {errors.status && touched.status && (
                                                        <div className="error">{errors.status}</div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>

                                    <Row>
                                        <Col className="mt-3">
                                            <button
                                                className={`${"exam_button"} ${"save_changes"}`}
                                                type="submit"
                                                onClick={() => {
                                                    dispatch(clearPostCreateFormDetailMessageResponse())

                                                }}
                                            >
                                                Save
                                            </button>
                                            {postCreateFormDetailError &&
                                                <div className="error">
                                                    {postCreateFormDetailError?.error}
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </form>
                    )
                }
                }
            </Formik>
        </div >
    )
}

export default ManageInputForm